import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLetterZSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconLetterZSquare"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM8.9043 7.77246V9.04395H13.2285V9.14941L8.78125 15.2197V16.2275H15.209V14.9561H10.668V14.8506L15.0977 8.78027V7.77246H8.9043Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLetterZSquare;
